// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleCommunityPage: action.mostCreativePeopleCommunityPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'most-creative-people',
        'categoryPage'
      );

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunityPage,
        ads: adModelData
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunityPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
